import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Loading = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.quartenary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.gray.primary};
`;

export const Progress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ProgressLabel = styled.span`
  font-family: ${({ theme }) => theme.typography.quartenary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray.denary};
`;

export const ProgressTrack = styled.div`
  height: 6px;
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.gray.senary};
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $percentage: number }>`
  height: 100%;
  width: ${({ $percentage }) => `${$percentage}%`};
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.green.tertiary};

  @media (prefers-reduced-motion: no-preference) {
    transition: width 0.3s ease;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Item = styled.button<{ $done: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 12px 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray.senary};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white.primary};
  cursor: ${({ $done }) => ($done ? 'default' : 'pointer')};
  text-align: left;
  font-family: ${({ theme }) => theme.typography.quartenary};

  @media (prefers-reduced-motion: no-preference) {
    transition: border-color 0.15s ease;
  }

  &:hover {
    border-color: ${({ theme, $done }) =>
      $done ? theme.colors.gray.senary : theme.colors.green.tertiary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.green.tertiary};
    outline-offset: 2px;
  }
`;

export const ItemName = styled.span<{ $done: boolean }>`
  flex: 1;
  min-width: 0;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme, $done }) =>
    $done ? theme.colors.gray.primary : 'rgba(0, 0, 0, 0.8)'};
  text-decoration: ${({ $done }) => ($done ? 'line-through' : 'none')};
`;

export const ItemPoints = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.green.light};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.black.quinary};
`;

export const ItemDoneBadge = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.green.light};
  background: ${({ theme }) => theme.colors.white.primary};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.green.dark};
`;
